// extracted by mini-css-extract-plugin
module.exports = {"wrapper-overrides":"styles-module__wrapper-overrides___1hzMB"};